module.exports = __webpack_public_path__ + "media/images/index/area/faeture_shikoku-6b4eb85f166eed33e3426232be0c2582.png";